import { Node, mergeAttributes, nodeInputRule } from '@tiptap/core';
import { TextSelection, NodeSelection } from '@tiptap/pm/state';
var HorizontalRule = Node.create({
  name: 'horizontalRule',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: 'block',
  parseHTML: function parseHTML() {
    return [{
      tag: 'hr'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['hr', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setHorizontalRule: function setHorizontalRule() {
        return function (_ref2) {
          var chain = _ref2.chain,
              state = _ref2.state;
          var $originTo = state.selection.$to;
          var currentChain = chain();

          if ($originTo.parentOffset === 0) {
            currentChain.insertContentAt(Math.max($originTo.pos - 2, 0), {
              type: _this.name
            });
          } else {
            currentChain.insertContent({
              type: _this.name
            });
          }

          return currentChain // set cursor after horizontal rule
          .command(function (_ref3) {
            var tr = _ref3.tr,
                dispatch = _ref3.dispatch;

            var _a;

            if (dispatch) {
              var $to = tr.selection.$to;
              var posAfter = $to.end();

              if ($to.nodeAfter) {
                if ($to.nodeAfter.isTextblock) {
                  tr.setSelection(TextSelection.create(tr.doc, $to.pos + 1));
                } else if ($to.nodeAfter.isBlock) {
                  tr.setSelection(NodeSelection.create(tr.doc, $to.pos));
                } else {
                  tr.setSelection(TextSelection.create(tr.doc, $to.pos));
                }
              } else {
                // add node after horizontal rule if it’s the end of the document
                var node = (_a = $to.parent.type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.create();

                if (node) {
                  tr.insert(posAfter, node);
                  tr.setSelection(TextSelection.create(tr.doc, posAfter + 1));
                }
              }

              tr.scrollIntoView();
            }

            return true;
          }).run();
        };
      }
    };
  },
  addInputRules: function addInputRules() {
    return [nodeInputRule({
      find: /^(?:---|—-|___\s|\*\*\*\s)$/,
      type: this.type
    })];
  }
});
export { HorizontalRule, HorizontalRule as default };